<template>
<div class="chapter">
<div class="inner_page">
<p class="fm"><a id="page_ii"></a>I dedicate this book to my paternal relations,</p>
<p class="fm1">Hardys, Baileys and Ostcliffes,</p>
<p class="fm1">who laboured in the coal mines of the West Riding of Yorkshire.</p>
<p class="fmt">In remembrance of all mineworkers throughout the ages, especially victims of colliery disasters or accidents.</p>
<p class="fm1">Barnsley, like many places, was built on their blood, sweat and tears.</p>
<div class="img_container"><img alt="images" src="images/f00ii-01.jpg"/>
<p class="caption">Sculpture by Graham Ibbeson at the National Union of Mineworkers Offices.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_Ded.vue?468e3986